// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px; }

.loading div {
  position: fixed;
  background: #fff;
  opacity: 1;
  border-radius: 50%;
  z-index: 9999;
  left: 0px;
  top: 0px;
  animation: loading 1.4s cubic-bezier(0, 0.2, 0.8, 1) infinite; }

.loading div:nth-child(2) {
  animation-delay: -0.7s; }

@keyframes loading {
  0% {
    top: 28px;
    left: 28px;
    width: 0;
    height: 0;
    opacity: 1; }
  100% {
    top: -1px;
    left: -1px;
    width: 58px;
    height: 58px;
    opacity: 0; } }

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  background: white; }

.f1 {
  position: relative;
  top: 0;
  left: 0;
  animation: rotation1 8s infinite linear; }

.f2 {
  position: absolute;
  animation: rotation2 8s infinite linear; }

@keyframes rotation1 {
  from {
    transform: rotate(0deg); }
  to {
    transform: rotate(359deg); } }

@keyframes rotation2 {
  from {
    transform: rotate(359deg); }
  to {
    transform: rotate(0deg); } }
`, "",{"version":3,"sources":["webpack://./src/Core/Loader/LoaderComponent.scss"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;;AAEd;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,QAAQ;EACR,6DAA6D,EAAA;;AAE/D;EACE,sBAAsB,EAAA;;AAExB;EACE;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU,EAAA;EAEZ;IACE,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU,EAAA,EAAA;;AAoCd;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EAInB,iBAA8B,EAAA;;AAIhC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,uCAAuC,EAAA;;AAGzC;EACE,kBAAkB;EAClB,uCAAuC,EAAA;;AAKzC;EACE;IACE,uBAAuB,EAAA;EAEzB;IACE,yBAAyB,EAAA,EAAA;;AAI7B;EACE;IACE,yBAAyB,EAAA;EAE3B;IACE,uBAAuB,EAAA,EAAA","sourcesContent":[".loading {\n  display: inline-block;\n  position: relative;\n  width: 64px;\n  height: 64px;\n}\n.loading div {\n  position: fixed;\n  background: #fff;\n  opacity: 1;\n  border-radius: 50%;\n  z-index: 9999;\n  left: 0px;\n  top: 0px;\n  animation: loading 1.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n.loading div:nth-child(2) {\n  animation-delay: -0.7s;\n}\n@keyframes loading {\n  0% {\n    top: 28px;\n    left: 28px;\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    top: -1px;\n    left: -1px;\n    width: 58px;\n    height: 58px;\n    opacity: 0;\n  }\n}\n\n// .loader {\n//   display: flex;\n//   justify-content: center;\n//   align-items: center;\n//   min-width: 100vw;\n//   height: 100vh;\n//   background: rgb(255, 255, 255);\n//   position: fixed;\n// }\n// .loader > div {\n//   width: 20px;\n//   height: 20px;\n//   background: #8385aa;\n//   opacity: 0.5;\n//   border-radius: 50%;\n//   margin: 3px;\n//   animation: loader 0.6s infinite alternate;\n// }\n// .loader > div:nth-child(2) {\n//   animation-delay: 0.2s;\n// }\n// .loader > div:nth-child(3) {\n//   animation-delay: 0.4s;\n// }\n// @keyframes loader {\n//   to {\n//     opacity: 0.1;\n//     transform: translate(0, -20px);\n//     background: pink;\n//   }\n// }\n\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  // min-width: 100%;\n  // width: 100%;\n  // height: 100%;\n  background: rgb(255, 255, 255);\n  // position: fixed;\n}\n\n.f1 {\n  position: relative;\n  top: 0;\n  left: 0;\n  animation: rotation1 8s infinite linear;\n}\n\n.f2 {\n  position: absolute;\n  animation: rotation2 8s infinite linear;\n  // top: 0;\n  // left: 0;\n}\n\n@keyframes rotation1 {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes rotation2 {\n  from {\n    transform: rotate(359deg);\n  }\n  to {\n    transform: rotate(0deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
